import React, { lazy } from 'react';

import { ALLOWED_ROLES, REMOTE_CONFIG_KEYS, withRemoteConfigKey } from '@src/packages/utils';

import AddressesRouteWrapper from './components/AddressesRouteWrapper';
import { PATHS } from './constants';

const Addresses = lazy(() => import('./screens/Addresses'));

const routes = [
  {
    component: (props: Record<string, unknown>) => (
      <AddressesRouteWrapper component={Addresses} routeProps={props} />
    ),
    path: PATHS.BASE_URL,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.ADDRESSES.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.TIME_TRACKER, routes);
